<div class="table-container border-1 border-neutral-base-primary-border border-round-lg">
  @if (tableData()) {
    <table class="w-full">
      <caption class="hidden"></caption>
      <thead>
        <tr class="border-bottom-1 border-neutral-base-primary-border">
          @if (showIndex()) {
            <th class="py-spacing-xs px-spacing-md text-caption-color font-normal index">
              <span class="content">#</span>
            </th>
          }
          @for (col of tableData()!.columns; track $index) {
            @if (col.name != "id") {
              <th class="py-spacing-xs px-spacing-md text-caption-color font-normal">
                <span
                  class="content"
                  [ngClass]="{ capitalize: !col.displayName }">
                  {{ col.displayName ? col.displayName : (col.name | keyDisplayName) }}
                </span>
              </th>
            }
          }
        </tr>
      </thead>

      <tbody>
        @for (item of tableData()!.data; track $index) {
          <tr>
            @if (showIndex()) {
              <td class="p-spacing-md bg-white text-secondary-color line-height-3 index">
                <div class="content flex-column">
                  <span>{{ $index + 1 }}</span>
                  @if (item["attentionDescription"]) {
                    <span
                      class="attention-dot"
                      [pTooltip]="attentionTooltip"
                      tooltipPosition="left"
                      [autoHide]="false"></span>
                  }
                  <ng-template #attentionTooltip>
                    <div class="tooltip-head background-fill-tertiary-bg">
                      <span class="flex align-items-center gap-spacing-xs"> <i class="icon-warning-solid feedback-danger-fg-color size-icon-md"></i> Attention </span>
                    </div>
                    <div class="tooltip-body">
                      <hr
                        class="m-0 background-fill-primary-border"
                        style="position: relative; top: -0.5rem" />
                      {{ item["attentionDescription"] }}
                    </div>
                  </ng-template>
                </div>
              </td>
            }
            @for (col of tableData()!.columns; track $index) {
              @if (col.name != "id") {
                <td class="p-spacing-md bg-white text-secondary-color line-height-3">
                  <div class="content flex flex-column gap-spacing-default">
                    @if (col.type == tableColumnsType.array) {
                      @for (el of item[col["name"]]; let i = $index; track i) {
                        @if (col.name != tableColumnsType.contacts && col.name != tableColumnsType.equipment) {
                          <span>{{ el }}</span>
                        } @else if (col.name == tableColumnsType.contacts) {
                          <span>{{ el.name }}</span>
                          <div class="flex gap-spacing-default flex-column lg:flex-row">
                            <span class="text-sm form-border-hover-color max-w-max px-spacing-default border-1 form-border-default-border line-height-2 border-round">
                              {{ el.relation }}
                            </span>
                            <span class="text-light-color text-sm">{{ el.number }}</span>
                            @if (el.isPrimary && tableName() === "students") {
                              <span
                                class="text-sm text-white max-w-max px-spacing-default border-1 line-height-2 border-round"
                                style="background-color: #3b82f6; border-color: #0066cc"
                                >Primary</span
                              >
                            }
                          </div>
                        } @else if (col.name == tableColumnsType.equipment) {
                          <div class="flex flex-row gap-spacing-md">
                            @if (el.icon) {
                              <img
                                width="32px"
                                [src]="el.icon"
                                alt="" />
                            }
                            <span>{{ el.name }}</span>
                          </div>
                        }
                      }
                    } @else if (col.type == tableColumnsType.icon) {
                      <span>
                        @if (item[col["name"]] == "no-icon") {
                          <span class="text-secondary-color text-sm">No Icon</span>
                        }
                        <img
                          width="48px"
                          [src]="item[col['name']]"
                          alt="" />
                      </span>
                    } @else if (col.type == tableColumnsType.button) {
                      <span
                        [pTooltip]="tooltipContent"
                        tooltipPosition="bottom"
                        [autoHide]="false"
                        class="text-link-color text-sm font-medium cursor-pointer">
                        {{ col["buttonLabel"] }}
                      </span>

                      <ng-template #tooltipContent>
                        <div class="tooltip-body">
                          <span class="title item border-neutral-base-primary-color">{{ col["displayName"] }}</span>

                          @if (item[col["name"]]?.length > 0) {
                            @for (tooltipItem of item[col["name"]]; track $index) {
                              @if (col["name"] == tableColumnsType.studentInstructions) {
                                <div
                                  class="item"
                                  style="max-width: 300px">
                                  <span>{{ tooltipItem.type }}</span>
                                  <span class="border-neutral-base-primary-color">{{ tooltipItem.description }}</span>
                                </div>
                              } @else if (col["name"] == tableColumnsType.contacts) {
                                <div class="item">
                                  <span class="capitalize"
                                    >{{ tooltipItem.name }} ({{ tooltipItem.relation }})
                                    @if (tooltipItem.isPrimary) {
                                      - Primary
                                    }
                                  </span>
                                  <ul class="mb-0 pl-spacing-3xl">
                                    <li class="border-neutral-base-primary-color">{{ tooltipItem.number }}</li>
                                  </ul>
                                </div>
                              }
                            }
                          } @else {
                            <div class="item">
                              <span>No {{ col["displayName"] }} Available</span>
                            </div>
                          }
                        </div>
                      </ng-template>
                    } @else {
                      <span
                        [pTooltip]="col.name == 'email' ? item[col['name']] : ''"
                        tooltipPosition="bottom"
                        [autoHide]="false"
                        >{{ col.name == "email" ? (item[col["name"]]?.length > 20 ? (item[col["name"]] | slice: 0 : 20) + "..." : item[col["name"]]) : item[col["name"]] ? item[col["name"]] : "N/A" }}</span
                      >

                      @if (col.hasTag) {
                        <span class="text-sm align-self-start form-border-hover-color px-spacing-default border-1 form-border-default-border line-height-2 border-round">
                          {{ col.tag }}
                        </span>
                      }
                    }
                  </div>
                </td>
              }
            }
          </tr>
        }
      </tbody>
    </table>
  }
</div>
